import React from "react";

const Footer = () => {
  return <footer className="landing-footer">footer</footer>;
};

export default Footer;
